import { Drawer } from '@mui/material'
import { CHIP_SIZE, CHIP_TYPE, COLORS, Chip } from '@repo/design-system/index'
import { QIcon_chevron_down, QIcon_close_default, QIcon_star_filled } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import { useEffect, useRef, useState } from 'react'
import { useAITutorJobs, useAITutorUserJob } from '../../../modules/apis/student/ai-tutor'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_ai_tutor, n_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import LoadingSpinner from '../../common/LoadingSpinner'
import PopperTooltip from '../../common/tooltip/PopperTooltip'
import JobSelection from '../../landing/profile/JobSelection'
import AITutorCourseRequest from '../../new-portal/ai-tutor/AITutorCourseRequest'
import VOCBanner from '../../new-portal/ai-tutor/AITutorVOCBanner'
import { useJobCategory } from '../../new-portal/ai-tutor/Hooks'
import WebviewStackContainer from '../common/WebviewStackContainer'

const AITutorList = dynamic(() => import('../../new-portal/ai-tutor/AITutorList'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const AITutorCategoryBottomSheet = ({
  categories = [],
  show,
  setShow,
  setCategory,
  setJobCategoryId,
  userJobCategoryId,
}) => {
  const { t } = useTranslation()

  const onClickCategory = (jobId, categoryId) => {
    setCategory?.(jobId)
    setJobCategoryId?.(categoryId)
    setShow(false)
  }

  console.log('categories ====>', categories)

  return (
    <Drawer
      open={show}
      anchor={'bottom'}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      onClose={(_e) => setShow(false)}
    >
      <div
        style={{
          height: '90vh',
          maxHeight: '90%',
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          backgroundColor: 'white',
          overflow: 'scroll',
        }}
      >
        <div className="flex flex-col px-[20px] mb-[60px]">
          <div className="flex flex-row justify-between items-center w-full mb-[32px] pt-[32px]">
            <div className="Title2-18Bd">{t(n_ai_tutor.course.chage_title)}</div>
            <QIcon_close_default onClick={() => setShow(false)} width={24} height={24} />
          </div>
          <JobSelection jobs={categories} onClickCategory={onClickCategory} userJobCategoryId={userJobCategoryId} />
        </div>
      </div>
    </Drawer>
  )
}

const AITutorCategory = ({ category, setCategory, setJobCategoryId, categories, userJobCategoryId }) => {
  const [showCategoryBottomSheet, setShowCategoryBottomSheet] = useState(false)
  const { t } = useTranslation()
  const anchorRef = useRef()
  const [tooltipOpen, setTooltipOpen] = useState(false)

  useEffect(() => {
    const closed = localStorage.getItem('courseTooltipClosedAtAITutorListActivity')
    if (!closed) {
      setTooltipOpen(true)
    }
  }, [])

  const handleClose = () => {
    setTooltipOpen(false)
    localStorage.setItem('courseTooltipClosedAtAITutorListActivity', '1')
  }

  console.log('🟡categories in tag ====>', categories)

  const selectedCategory = categories.find((c) => c.id === category)

  return (
    <>
      <div
        className="rounded-lg pt-[4px] pb-[4px] flex flex-row gap-[8px] items-center justify-start"
        onClick={() => setShowCategoryBottomSheet(true)}
      >
        <div className="text-gray-700 Title2-18Bd relative flex-1">
          {categories.find((c) => c.id === category)?.title}
        </div>
        <div className="p-[4px] border-[1.5px] border-gray-200 rounded-[4px]" ref={anchorRef}>
          <QIcon_chevron_down width={16} height={16} color={COLORS.BLACK} />
        </div>
      </div>
      <PopperTooltip anchorEl={anchorRef.current} open={tooltipOpen} onClose={handleClose} zIndex={10}>
        <span>{t(n_ai_tutor.study.course_tooltip_2)}</span>
      </PopperTooltip>
      <AITutorCategoryBottomSheet
        show={showCategoryBottomSheet}
        setShow={setShowCategoryBottomSheet}
        setCategory={setCategory}
        setJobCategoryId={setJobCategoryId}
        categories={categories}
        userJobCategoryId={userJobCategoryId}
      />
    </>
  )
}

export const AITutorJobTag = ({ jobs, jobId, setJobId, userJobId }) => {
  return (
    <div className="overflow-x-auto Body2-14Md no-scrollbar">
      <div className="flex py-[8px] gap-[8px] items-center justify-start w-max">
        {jobs?.map((job) => (
          <Chip
            type={CHIP_TYPE.CHOICE}
            size={CHIP_SIZE.MD}
            initialSelected={job.id === jobId}
            onClick={() => setJobId(job.id)}
            key={job.id}
          >
            <Chip.Label className="inline-flex items-center">
              <span>{job.title}</span>
              {job.id == userJobId && (
                <QIcon_star_filled color={COLORS.YELLOW400} width={16} height={16} className="ml-[4px]" />
              )}
            </Chip.Label>
          </Chip>
        ))}
      </div>
    </div>
  )
}

const GLOBAL_FIELD_ENGLISH_ID = 23
export const AITutorTag = ({ jobId, jobCategoryId, setJobCategoryId }) => {
  const { t } = useTranslation()
  const categories = useJobCategory(jobId) || []
  const allCategory = { id: null, job_id: jobId, order: 0, title: t(n_ai_tutor.course.filter_all) }
  const moreCategory =
    jobId === GLOBAL_FIELD_ENGLISH_ID
      ? { id: 0, job_id: 0, order: categories.length + 1, title: t(n_common.btn_more) }
      : null

  const tagList = [allCategory, ...categories]
  if (moreCategory) tagList.push(moreCategory)

  return (
    <div className="overflow-x-auto Body2-14Md no-scrollbar">
      <div className="flex py-[8px] gap-[8px] items-center justify-start w-max">
        {tagList?.map((tag) => (
          <Chip
            type={CHIP_TYPE.CHOICE}
            size={CHIP_SIZE.MD}
            initialSelected={tag.id === jobCategoryId}
            onClick={() => setJobCategoryId(tag.id)}
            key={tag.id}
          >
            <Chip.Label>{tag.title}</Chip.Label>
          </Chip>
        ))}
      </div>
    </div>
  )
}

const AiTutorActivityHeader = ({ progress = 0, jobId, setJobId, setJobCategoryId, categories, userJobCategoryId }) => {
  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const router = useAppRouter({ stackPush: push, browserDetect: true })
  const routerMoveListPage = () => {
    router.back()
  }

  console.log('✅ ategories in header ====>', categories)
  return (
    <>
      <header className="fixed z-10 bg-white flex w-full px-[20px] gap-[16px] h-[52px] items-center justify-between">
        <AITutorCategory
          category={jobId}
          setCategory={setJobId}
          setJobCategoryId={setJobCategoryId}
          categories={categories}
          userJobCategoryId={userJobCategoryId}
        />
        <QIcon_close_default width={24} height={24} color={COLORS.BLACK} onClick={() => routerMoveListPage()} />
      </header>
    </>
  )
}

const AITutorListActivity: ActivityComponentType = () => {
  const [jobId, setJobId] = useState(8) // 공통 직군으로 디폴트 세팅
  const [jobCategoryId, setJobCategoryId] = useState(null)
  // const { data: currentAITutorCourseJob } = useAITutorLatestJob()
  const { data: AITutorJobList } = useAITutorJobs()
  const { data: userJobData } = useAITutorUserJob()

  useEffect(() => {
    if (userJobData?.id) {
      setJobId(userJobData.id)
    }
  }, [userJobData])

  return (
    <WebviewStackContainer
      height="52px"
      title={
        <AiTutorActivityHeader
          jobId={jobId}
          setJobId={setJobId}
          setJobCategoryId={setJobCategoryId}
          categories={AITutorJobList || []}
          userJobCategoryId={userJobData?.job_category_id}
        />
      }
      border={false}
    >
      <div className="px-[20px]">
        <AITutorTag jobId={jobId} jobCategoryId={jobCategoryId} setJobCategoryId={setJobCategoryId} />
      </div>
      {jobCategoryId === 0 ? <AITutorCourseRequest /> : <AITutorList jobId={jobId} jobCategoryId={jobCategoryId} />}
      <VOCBanner jobId={jobId} jobCategoryId={jobCategoryId} JobList={AITutorJobList} />
    </WebviewStackContainer>
  )
}

export default AITutorListActivity
